<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="3" class="request-label">
        Datum změny
      </v-col>

      <v-col cols="9" class="request-value">
        {{ dateFormattingHours(updatedAt) || missingValueString }}
      </v-col>
    </v-row>

    <h2 class="mt-4">
      Roční rezervovaná kapacita
    </h2>

    <v-row>
      <v-col cols="3" class="request-label">
        Stávající hodnota
      </v-col>

      <v-col cols="3" class="request-value">
        <div class="d-inline-flex align-center justify-center px-4">
          {{ individualCapacityChangeAnnual.currentBookedCapacity || missingValueString }} kW
        </div>
      </v-col>

      <v-col cols="3" class="request-label">
        Nová hodnota
      </v-col>

      <v-col cols="3" class="request-value">
        <div class="d-inline-flex align-center justify-center px-4">
          {{ individualCapacityChangeAnnual.newBookedCapacity || missingValueString }} kW
        </div>
      </v-col>

      <v-col cols="3" class="request-label">
        Požadovaný termín změny
      </v-col>

      <v-col cols="3" class="request-value">
        <div class="d-inline-flex align-center justify-center px-4">
          {{
            dateFormatting(individualCapacityChangeAnnual.requiredChangeDate) || missingValueString
          }}
        </div>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'IndividualCapacityChangeAnnualInsertedValues',
  props: {
    individualCapacityChangeAnnual: {
      type: Object,
      required: false,
    },
    updatedAt: {
      type: String,
      required: false,
    },
  },
};
</script>
